// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"bc518a61","211":"bd01af9a","296":"3f6939e9","552":"cf308a68","577":"3eb4b007","616":"4bb42aef","673":"632bd350","739":"47c9cbc1","892":"369933bd","982":"5b0bb30d"}[chunkId] + ".chunk.js";
};